import React from 'react';
import { Button } from '../components/buttons/Button/Button';
import { RotatingDotsLoader } from '../components/progress/RotatingDotsLoader';
import { BaseEnum } from './BaseEnum';

export const AuthState = {
    None: 0,
    AuthenticationError: 1,
    AuthenticatedWithContext: 2,
    LoggingIn: 3,
    UnauthenticatedOrSessionExpired: 4,
    SessionInactive: 5,
    Reconnecting: 6,
    RedirectToSSO: 7,

    callout: {
        1: {
            body: ({ bodyClassName, onRetryClick }) => (
                <Button variant="light" className={bodyClassName} onClick={onRetryClick}>
                    Click here to reconnect.
                </Button>
            ),
            header: "We're sorry, your connection was interrupted...",
        },
        3: {
            body: ({ bodyClassName }) => <RotatingDotsLoader className={bodyClassName} hideText />,
            header: 'Loading your session...',
        },
        4: {
            body: ({ bodyClassName, onLoginClick }) => (
                <Button variant="light" className={bodyClassName} onClick={onLoginClick}>
                    Click here to log back in.
                </Button>
            ),
            header: 'You were logged out.',
            title: 'Care Continuity Login',
        },
        5: {
            body: ({ bodyClassName, onLoginClick }) => (
                <Button variant="light" className={bodyClassName} onClick={onLoginClick}>
                    Click here to log back in.
                </Button>
            ),
            header: 'You have been logged out due to inactivity.',
            title: 'Care Continuity Login',
        },
        6: {
            body: ({ bodyClassName }) => <RotatingDotsLoader className={bodyClassName} hideText />,
            header: 'Re-establishing connection...',
        },
        7: {
            body: ({ bodyClassName }) => <RotatingDotsLoader className={bodyClassName} hideText />,
            header: 'Loading...',
        },
    },

    ...BaseEnum,
};
